<form [formGroup]="form" (ngSubmit)="onSubmit()" class="donor-form">
  <div class="donor-form__fields">
  <div class="donor-form__field">
    <label class="donor-form__label" for="floatingInputEmail">{{ 'CAMPAIGN.Inputs.Email' | translate }} <span class="text-danger">*</span></label>
    <input type="email" class="form-control" id="floatingInputEmail" placeholder="name@example.com"
      [class.is-invalid]="getError('email')" formControlName="email" />
    <div *ngIf="getError('email')" class="text-danger small mt-1">{{ getError('email') | translate }}</div>
  </div>

  <div class="donor-form__grid donor-form__grid--two">
    <div class="donor-form__field col-12 col-md">
      <label class="donor-form__label" for="floatingInputFirstName">{{ 'CAMPAIGN.Inputs.FirstName' | translate }} <span
          class="text-danger">*</span></label>
      <input type="text" class="form-control" id="floatingInputFirstName" placeholder="First name"
        [class.is-invalid]="getError('firstName')" formControlName="firstName" />
      <div *ngIf="getError('firstName')" class="text-danger small mt-1">{{ getError('firstName') | translate }}</div>
    </div>
    <div class="donor-form__field col-12 col-md">
      <label class="donor-form__label" for="floatingInputLastName">{{ 'CAMPAIGN.Inputs.LastName' | translate }} <span
          class="text-danger">*</span></label>
      <input type="text" class="form-control" id="floatingInputLastName" placeholder="Last name"
        [class.is-invalid]="getError('lastName')" formControlName="lastName" />
      <div *ngIf="getError('lastName')" class="text-danger small mt-1">{{ getError('lastName') | translate }}</div>
    </div>
  </div>

  <phone-input [countries]="mappedCountries" [defaultCountry]="'MX'" formControlName="phone">
  </phone-input>

  <div *ngIf="form.get('isCompany')?.value">
    <div class="donor-form__field">
      <label class="donor-form__label" for="companyName">{{ 'CAMPAIGN.CompanyName' | translate }} <span class="text-danger">*</span></label>
      <input type="text" class="form-control" id="companyName" placeholder="Company name"
        [class.is-invalid]="getError('companyName')" formControlName="companyName" />
      <div *ngIf="getError('companyName')" class="text-danger small mt-1">{{ getError('companyName') | translate }}</div>
    </div>
  </div>

  <h6 class="donor-form__section-title">{{ 'CAMPAIGN.BillingAddress' | translate }} <span class="text-danger">*</span></h6>

  <div class="donor-form__grid donor-form__grid--two">

    <select-input formControlName="country" [label]="'CAMPAIGN.Inputs.Country' | translate"
      [placeholder]="'CAMPAIGN.Inputs.SelectCountry' | translate" [options]="countryOptions"
      [searchable]="true" [searchPlaceholder]="'CAMPAIGN.Inputs.SearchCountry' | translate"></select-input>

    <select-input formControlName="state" [label]="'CAMPAIGN.Inputs.State' | translate"
      [placeholder]="'CAMPAIGN.Inputs.SelectState' | translate" [options]="stateOptions"
      [searchable]="true" [searchPlaceholder]="'CAMPAIGN.Inputs.SearchState' | translate"></select-input>

  </div>

  <div class="donor-form__grid donor-form__grid--two">
    <div class="donor-form__field col-12 col-md">
      <label class="donor-form__label" for="floatingInputCity">{{ 'CAMPAIGN.Inputs.City' | translate }} <span class="text-danger">*</span></label>
      <input type="text" class="form-control" id="floatingInputCity" placeholder="City"
        [class.is-invalid]="getError('city')" formControlName="city" />
      <div *ngIf="getError('city')" class="text-danger small mt-1">{{ getError('city') | translate }}</div>
    </div>
    <div class="donor-form__field col-12 col-md">
      <label class="donor-form__label" for="floatingInputPostal">{{ 'CAMPAIGN.Inputs.PostalCode' | translate }} <span
          class="text-danger">*</span></label>
      <input type="text" class="form-control" id="floatingInputPostal" placeholder="Postal Code"
        [class.is-invalid]="getError('postalCode')" formControlName="postalCode" inputmode="numeric"
        onKeyDown="if(this.value.length==5 && event.key !== 'Backspace' && event.key !== 'Delete'){ event.preventDefault(); }"
        required />
      <div *ngIf="getError('postalCode')" class="text-danger small mt-1">{{ getError('postalCode') | translate }}</div>
    </div>
  </div>

  <div class="donor-form__field">
    <label class="donor-form__label" for="floatingInputLine1">{{ 'CAMPAIGN.Inputs.Street' | translate }} <span
        class="text-danger">*</span></label>
    <input type="text" class="form-control" id="floatingInputLine1" placeholder="Street Address"
      [class.is-invalid]="getError('line1')" formControlName="line1" />
    <div *ngIf="getError('line1')" class="text-danger small mt-1">{{ getError('line1') | translate }}</div>
  </div>

  <div class="donor-form__field">
    <label class="donor-form__label" for="floatingInputLine2">{{ 'CAMPAIGN.Inputs.AptSuite' | translate }}</label>
    <input type="text" class="form-control" id="floatingInputLine2"
      [placeholder]="'CAMPAIGN.Inputs.AptSuite' | translate" formControlName="line2" />
  </div>
  </div>

  <div *ngIf="form.invalid && submitted" class="text-danger small">
    {{ 'CAMPAIGN.Inputs.Errors.FormInvalid' | translate }}
  </div>

  <div class="donor-form__actions" [class.donor-form__actions--single]="!showBackButton">
    <button *ngIf="showBackButton" type="button" class="btn btn-outline-secondary" (click)="onBackClick()">
      <span aria-hidden="true">←</span> {{ backButtonLabel || ('CAMPAIGN.Checkout.Back' | translate) }}
    </button>

    <button class="btn btn-primary" [disabled]="form.pending || form.invalid" type="submit">
      {{ 'CAMPAIGN.Checkout.ReviewDonation' | translate }} <span aria-hidden="true">→</span>
    </button>
  </div>
</form>